export default "__VITE_ASSET__bc5b528f__"